import { callPost } from '../../services/axios.js'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import {
  CREATE_WP_TEMPLATE,
  UPDATE_WP_TEMPLATE,
} from '../actionTypes/weekparting.js'

export const getWpStats = (accessToken, spCampaignIds, sdCampaignIds, sbCampaignIds,
  lookback, timezone) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/weekparting/getStats', {
    userId: currentUserId,
    spCampaignIds,
    sdCampaignIds,
    sbCampaignIds,
    lookback,
    timezone,
  }, accessToken)
}

export const loadWpRules = (accessToken, campaignIds) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/weekparting/loadRules', {
    userId: currentUserId,
    campaignIds,
  }, accessToken).then(response => response.data)
}

export const saveWpRules = (accessToken, campaignIds, status, timezone,
  lookback, slots, templateIds, clearDows) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/weekparting/saveRules', {
    userId: currentUserId,
    campaignIds,
    status,
    timezone,
    lookback,
    slots,
    templateIds,
    clearDows,
  }, accessToken).then(() => {
    toast.show({
      title: 'Success',
      description: 'Successfully saved rules.',
    })
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to save rules.',
    })
  })
}

export const saveWpTemplate = (accessToken, name, timezone, slots,
  needApply = false, campaignIds = []) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/weekparting/saveTemplate', {
    name,
    timezone,
    slots,
    needApply,
    userId: currentUserId,
    campaignIds,
  }, accessToken).then((response) => {
    toast.show({
      title: 'Success',
      description: 'Successfully saved template.',
    })

    dispatch({
      type: CREATE_WP_TEMPLATE,
      template: response.data,
    })

    return response.data
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to save template.',
    })
    return null
  })
}

export const updateWpTemplate = (accessToken, templateId, name, timezone, slots) => (dispatch) => {
  return callPost('/weekparting/updateTemplate', {
    templateId,
    name,
    timezone,
    slots,
  }, accessToken).then((response) => {
    toast.show({
      title: 'Success',
      description: 'Successfully updated template.',
    })

    dispatch({
      type: UPDATE_WP_TEMPLATE,
      template: response.data,
    })
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to update template.',
    })
  })
}
